import { PlanMainService } from './../../../plan/service/plan-main.service';
import {
  NgModule,
  Component,
  ElementRef,
  AfterViewInit,
  AfterViewChecked,
  OnDestroy,
  OnInit,
  Input,
  Output,
  SimpleChange,
  EventEmitter,
  forwardRef,
  Renderer2,
  ViewChild,
  ChangeDetectorRef,
  OnChanges,
  ContentChildren,
  QueryList,
  TemplateRef
} from '@angular/core';
import {
  trigger,
  state,
  style,
  transition,
  animate
} from '@angular/animations';
import { CommonModule } from '@angular/common';
import {
  NG_VALUE_ACCESSOR,
  ControlValueAccessor,
  COMPOSITION_BUFFER_MODE
} from '@angular/forms';
import { DomHandler } from 'primeng/components/common/api';
import { PrimeTemplate } from 'primeng/components/common/shared';
import { CALENDAR_YEAR } from '../../../models/CALENDAR_YEAR';
import { UtilService } from '../../../services/util.service';

export const CALENDAR_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CalendarDateComponent),
  multi: true
};

export interface LocaleSettings {
  firstDayOfWeek?: number;
  dayNames: string[];
  dayNamesShort: string[];
  dayNamesMin: string[];
  monthNames: string[];
  monthNamesShort: string[];
  today: string;
  clear: string;
}

@Component({
  selector: 'app-calendar-date',
  templateUrl: './calendar-date.component.html',
  styleUrls: ['./calendar-date.component.css'],
  animations: [
    trigger('overlayState', [
      state(
        'hidden',
        style({
          opacity: 0
        })
      ),
      state(
        'visible',
        style({
          opacity: 1
        })
      ),
      transition('visible => hidden', animate('400ms ease-in')),
      transition('hidden => visible', animate('400ms ease-out'))
    ])
  ],
  host: {
    '[class.ui-inputwrapper-filled]': 'filled',
    '[class.ui-inputwrapper-focus]': 'focus'
  },
  providers: [DomHandler, CALENDAR_VALUE_ACCESSOR]
})
export class CalendarDateComponent
  implements
    AfterViewInit,
    AfterViewChecked,
    OnInit,
    OnDestroy,
    ControlValueAccessor,
    OnChanges {
  @Input() defaultDate: Date;

  @Input() kanjidate: any;

  @Input() style: string;

  @Input() styleClass: string;

  @Input() inputStyle: string;

  @Input() inputId: string;

  @Input() name: string;

  @Input() inputStyleClass: string;

  @Input() placeholder: string;

  @Input() disabled: any;

  @Input() dateFormat: string = 'mm/dd/yy';
  @Input() inline: boolean = false;

  @Input() showOtherMonths: boolean = true;

  @Input() selectOtherMonths: boolean;

  @Input() showIcon: boolean;

  @Input() icon: string = 'fa-calendar';

  @Input() appendTo: any;

  @Input() readonlyInput: boolean;

  @Input() shortYearCutoff: any = '+10';

  @Input() monthNavigator: boolean;

  @Input() yearNavigator: boolean;

  @Input() yearRange: string;

  @Input() hourFormat: string = '24';

  @Input() timeOnly: boolean;

  @Input() stepHour: number = 1;

  @Input() stepMinute: number = 1;

  @Input() stepSecond: number = 1;

  @Input() showSeconds: boolean = false;

  @Input() required: boolean;

  @Input() showOnFocus: boolean = true;

  @Input() dataType: string = 'date';

  @Input() utc: boolean;

  @Input() selectionMode: string = 'single';

  @Input() maxDateCount: number;

  @Input() showButtonBar: boolean;

  @Input() todayButtonStyleClass: string = 'ui-button-secondary';

  @Input() clearButtonStyleClass: string = 'ui-button-secondary';

  @Input() onoffChanges: boolean = true;

  @Input() onmaxLength: number;

  @Input() ondateClick: boolean = false;

  @Input() focusDate: boolean = false;

  @Input() autoformat: boolean = false;

  @Output() onFocus: EventEmitter<any> = new EventEmitter();

  @Output() onFocusDate: EventEmitter<any> = new EventEmitter();

  @Output() onBlur: EventEmitter<any> = new EventEmitter();

  @Output() onClose: EventEmitter<any> = new EventEmitter();

  @Output() onSelect: EventEmitter<any> = new EventEmitter();

  @Output() onInput: EventEmitter<any> = new EventEmitter();

  @Output() onTodayClick: EventEmitter<any> = new EventEmitter();

  @Output() onClearClick: EventEmitter<any> = new EventEmitter();

  @Output() onSwitch: EventEmitter<any> = new EventEmitter();

  @Output() onDataInput: EventEmitter<any> = new EventEmitter();

  @Output() onData: EventEmitter<any> = new EventEmitter();

  @Output() onmodedropdown: EventEmitter<any> = new EventEmitter();

  @Output() onsendEnter: EventEmitter<any> = new EventEmitter();

  public datainputem: string;

  @ContentChildren(PrimeTemplate) templates: QueryList<any>;

  _locale: LocaleSettings = {
    firstDayOfWeek: 0,
    dayNames: [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday'
    ],
    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    monthNames: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ],
    monthNamesShort: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ],
    today: 'Today',
    clear: 'Clear'
  };

  @Input() tabindex: number;

  @ViewChild('datepicker') overlayViewChild: ElementRef;

  @ViewChild('inputfield') inputfieldViewChild: ElementRef;

  value: any = null;

  dates: any[];

  weekDays: string[];

  currentMonthText: string;

  currentMonth: number;

  currentYear: number;

  currentHour: number;

  currentMinute: number;

  currentSecond: number;

  pm: boolean;

  overlay: HTMLDivElement;

  overlayVisible: boolean;

  overlayShown: boolean;

  datepickerClick: boolean;

  formatselectdate: string;
  statusyear: number;

  onModelChange: Function = () => {};

  onModelTouched: Function = () => {};

  calendarElement: any;

  documentClickListener: any;

  ticksTo1970: number;

  yearOptions: number[];

  focus: boolean;

  isKeydown: boolean;

  filled: boolean;

  inputFieldValue: string = null;

  _minDate: Date;

  _maxDate: Date;

  _showTime: boolean;

  preventDocumentListener: boolean;

  dateTemplate: TemplateRef<any>;

  _disabledDates: Array<Date>;

  _disabledDays: Array<number>;

  @Input()
  get minDate(): Date {
    return this._minDate;
  }

  set minDate(date: Date) {
    this._minDate = date;
    if (this.currentMonth && this.currentYear) {
      this.createMonth(this.currentMonth, this.currentYear);
    }
  }

  @Input()
  get maxDate(): Date {
    return this._maxDate;
  }

  set maxDate(date: Date) {
    this._maxDate = date;
    if (this.currentMonth && this.currentYear) {
      this.createMonth(this.currentMonth, this.currentYear);
    }
  }

  @Input()
  get disabledDates(): Date[] {
    return this._disabledDates;
  }

  set disabledDates(disabledDates: Date[]) {
    this._disabledDates = disabledDates;
    if (this.currentMonth && this.currentYear) {
      this.createMonth(this.currentMonth, this.currentYear);
    }
  }

  @Input()
  get disabledDays(): number[] {
    return this._disabledDays;
  }

  set disabledDays(disabledDays: number[]) {
    this._disabledDays = disabledDays;
    if (this.currentMonth && this.currentYear) {
      this.createMonth(this.currentMonth, this.currentYear);
    }
  }

  @Input()
  get showTime(): boolean {
    return this._showTime;
  }

  set showTime(showTime: boolean) {
    this._showTime = showTime;

    if (this.currentHour === undefined) {
      this.initTime(this.value || new Date());
    }
  }

  get locale() {
    return this._locale;
  }

  @Input()
  set locale(newLocale: LocaleSettings) {
    this._locale = newLocale;
    this.createWeekDays();
    this.createMonth(this.currentMonth, this.currentYear);
  }

  constructor(
    public el: ElementRef,
    public domHandler: DomHandler,
    public renderer: Renderer2,
    public cd: ChangeDetectorRef,
    public planmainservice: PlanMainService,
    private util: UtilService
  ) {}

  ngOnInit() {
    if (this.autoformat) {
      this.formatselectdate = 'yy/mm/dd';
    }
    let date = this.defaultDate || new Date();
    this.createWeekDays();

    this.currentMonth = date.getMonth();
    this.currentYear = date.getFullYear();
    this.initTime(date);

    this.createMonth(this.currentMonth, this.currentYear);

    this.ticksTo1970 =
      ((1970 - 1) * 365 +
        Math.floor(1970 / 4) -
        Math.floor(1970 / 100) +
        Math.floor(1970 / 400)) *
      24 *
      60 *
      60 *
      10000000;

    if (this.yearNavigator && this.yearRange) {
      this.yearOptions = [];
      let years = this.yearRange.split(':'),
        yearStart = parseInt(years[0]),
        yearEnd = parseInt(years[1]);

      for (let i = yearStart; i <= yearEnd; i++) {
        this.yearOptions.push(i);
      }
    }
  }

  ngAfterViewInit() {
    if (!this.inline && this.appendTo) {
      if (this.appendTo === 'body')
        document.body.appendChild(this.overlayViewChild.nativeElement);
      else
        this.domHandler.appendChild(
          this.overlayViewChild.nativeElement,
          this.appendTo
        );
    }
    if (this.focusDate && this.inputId) {
      (<HTMLInputElement>document.getElementById(this.inputId)).focus();
      setTimeout(() => {
        this.focus = true;
        if (this.showOnFocus) {
          this.showOverlay();
          this.onFocusDate.emit(false);
        }
      }, 0);
    }
  }

  ngAfterViewChecked() {
    if (this.overlayShown) {
      this.alignOverlay();
      this.overlayShown = false;
    }

    if (this.kanjidate == 0) {
      this.yearRange = '1926:2030';
    } else if (this.kanjidate == 1) {
      // this.yearRange = '1926:1988';
      this.yearRange = '1926:2030';
    } else if (this.kanjidate == 2) {
      // this.yearRange = '1989:2030';
      this.yearRange = '1926:2030';
    } else {
      this.yearRange = '1989:2030';
    }

    if (this.yearNavigator && this.yearRange) {
      this.yearOptions = [];
      let years = this.yearRange.split(':'),
        yearStart = parseInt(years[0]),
        yearEnd = parseInt(years[1]);

      for (let i = yearStart; i <= yearEnd; i++) {
        this.yearOptions.push(i);
      }
    }
  }

  ngOnChanges() {
    //console.log("calendar-date:ngOnChanges [START]");
    this.Onclean(this.kanjidate);
    //console.log("calendar-date:ngOnChanges :kanjidate" + this.kanjidate);
    //console.log("calendar-date:ngOnChanges [END]");
  }

  ngAfterContentInit() {
    this.templates.forEach(item => {
      switch (item.getType()) {
        case 'date':
          this.dateTemplate = item.template;
          break;

        default:
          this.dateTemplate = item.template;
          break;
      }
    });
  }

  createWeekDays() {
    this.weekDays = [];
    let dayIndex = this.locale.firstDayOfWeek;
    for (let i = 0; i < 7; i++) {
      this.weekDays.push(this.locale.dayNamesMin[dayIndex]);
      dayIndex = dayIndex == 6 ? 0 : ++dayIndex;
    }
  }

  createMonth(month: number, year: number) {
    this.dates = [];
    this.currentMonth = month;
    this.currentYear = year;
    this.currentMonthText = this.locale.monthNames[month];
    let firstDay = this.getFirstDayOfMonthIndex(month, year);
    let daysLength = this.getDaysCountInMonth(month, year);
    let prevMonthDaysLength = this.getDaysCountInPrevMonth(month, year);
    let sundayIndex = this.getSundayIndex();
    let dayNo = 1;
    let today = new Date();

    for (let i = 0; i < 6; i++) {
      let week = [];

      if (i == 0) {
        for (
          let j = prevMonthDaysLength - firstDay + 1;
          j <= prevMonthDaysLength;
          j++
        ) {
          let prev = this.getPreviousMonthAndYear(month, year);
          week.push({
            day: j,
            month: prev.month,
            year: prev.year,
            otherMonth: true,
            today: this.isToday(today, j, prev.month, prev.year),
            selectable: this.isSelectable(j, prev.month, prev.year)
          });
        }

        let remainingDaysLength = 7 - week.length;
        for (let j = 0; j < remainingDaysLength; j++) {
          week.push({
            day: dayNo,
            month: month,
            year: year,
            today: this.isToday(today, dayNo, month, year),
            selectable: this.isSelectable(dayNo, month, year)
          });
          dayNo++;
        }
      } else {
        for (let j = 0; j < 7; j++) {
          if (dayNo > daysLength) {
            let next = this.getNextMonthAndYear(month, year);
            week.push({
              day: dayNo - daysLength,
              month: next.month,
              year: next.year,
              otherMonth: true,
              today: this.isToday(
                today,
                dayNo - daysLength,
                next.month,
                next.year
              ),
              selectable: this.isSelectable(
                dayNo - daysLength,
                next.month,
                next.year
              )
            });
          } else {
            week.push({
              day: dayNo,
              month: month,
              year: year,
              today: this.isToday(today, dayNo, month, year),
              selectable: this.isSelectable(dayNo, month, year)
            });
          }

          dayNo++;
        }
      }

      this.dates.push(week);
    }
  }

  initTime(date: Date) {
    this.pm = date.getHours() > 11;
    if (this.showTime) {
      this.currentMinute = date.getMinutes();
      this.currentSecond = date.getSeconds();

      if (this.hourFormat == '12')
        this.currentHour = date.getHours() == 0 ? 12 : date.getHours() % 12;
      else this.currentHour = date.getHours();
    } else if (this.timeOnly) {
      this.currentMinute = 0;
      this.currentHour = 0;
      this.currentSecond = 0;
    }
  }

  prevMonth(event) {
    if (this.disabled) {
      event.preventDefault();
      return;
    }

    if (this.currentMonth === 0) {
      this.currentMonth = 11;
      this.currentYear--;

      if (this.yearNavigator && this.currentYear < this.yearOptions[0]) {
        this.currentYear = this.yearOptions[this.yearOptions.length - 1];
      }
    } else {
      this.currentMonth--;
    }

    this.createMonth(this.currentMonth, this.currentYear);
    event.preventDefault();
  }

  nextMonth(event) {
    if (this.disabled) {
      event.preventDefault();
      return;
    }

    if (this.currentMonth === 11) {
      this.currentMonth = 0;
      this.currentYear++;

      if (
        this.yearNavigator &&
        this.currentYear > this.yearOptions[this.yearOptions.length - 1]
      ) {
        this.currentYear = this.yearOptions[0];
      }
    } else {
      this.currentMonth++;
    }

    this.createMonth(this.currentMonth, this.currentYear);
    event.preventDefault();
  }

  onDateSelect(event, dateMeta) {
    //console.log("calendar-date:onDateSelect [START]");
    if (this.disabled || !dateMeta.selectable) {
      event.preventDefault();
      return;
    }
    if (this.formatselectdate != null) {
      this.dateFormat = this.formatselectdate;
    }
    this.oncheckvalue(dateMeta.year, dateMeta);

    if (this.isMultipleSelection() && this.isSelected(dateMeta)) {
      this.value = this.value.filter((date, i) => {
        return !this.isDateEquals(date, dateMeta);
      });
    } else {
      if (this.shouldSelectDate(dateMeta)) {
        if (dateMeta.otherMonth) {
          if (this.selectOtherMonths) {
            this.currentMonth = dateMeta.month;
            this.currentYear = dateMeta.year;
            this.createMonth(this.currentMonth, this.currentYear);
            this.selectDate(dateMeta);
          }
        } else {
          this.selectDate(dateMeta);
        }
      }
    }

    if (this.isSingleSelection()) {
      this.overlayVisible = false;
    }

//    if (this.kanjidate === 1) {
//      this.onmodedropdown.emit('S');
//    } else if (this.kanjidate === 2) {
//      this.onmodedropdown.emit('H');
//    } else {
//      this.onmodedropdown.emit('');
//    }

    this.updateInputfield();
    event.preventDefault();
    //console.log("calendar-date:onDateSelect [END]");
  }

  shouldSelectDate(dateMeta) {
    if (this.isMultipleSelection())
      return (
        !this.maxDateCount ||
        !this.value ||
        this.maxDateCount > this.value.length
      );
    else return true;
  }

  updateInputfield() {
    //console.log("updateInputfield [START]");
    //console.log("updateInputfield this.kanjidate: " + this.kanjidate);
    let formattedValue = '';
    if (this.value) {
      if (this.isSingleSelection()) {
        formattedValue = this.formatDateTime(this.value);
      } else if (this.isMultipleSelection()) {
        for (let i = 0; i < this.value.length; i++) {
          let dateAsString = this.formatDateTime(this.value[i]);
          formattedValue += dateAsString;
          if (i !== this.value.length - 1) {
            formattedValue += ', ';
          }
        }
      } else if (this.isRangeSelection()) {
        if (this.value && this.value.length) {
          let startDate = this.value[0];
          let endDate = this.value[1];

          formattedValue = this.formatDateTime(startDate);
          if (endDate) {
            formattedValue += ' - ' + this.formatDateTime(endDate);
          }
        }
      }
    }

    //console.log("updateInputfield formattedValue: " + formattedValue);
    this.inputFieldValue = formattedValue;
    this.updateFilledState();
    if (this.inputfieldViewChild && this.inputfieldViewChild.nativeElement) {
      this.inputfieldViewChild.nativeElement.value = this.inputFieldValue;
    }

    if (this.kanjidate < CALENDAR_YEAR.length) {
      this.onmodedropdown.emit(CALENDAR_YEAR[this.kanjidate].Char);
    } else {
      this.onmodedropdown.emit('');
    }

    //console.log("updateInputfield kanji:" + this.kanjidate);
    //console.log("updateInputfield [END]");
    this.onData.emit({
      value: this.value,
      format: this.formatDate(this.value, this.dateFormat)
    });
  }

  formatDateTime(date) {
    //console.log("calendar-date:formatDateTime [START]");
    let formattedValue = null;
    if (date) {
      if (this.timeOnly) {
        formattedValue = this.formatTime(date);
      } else {
        formattedValue = this.formatDate(date, this.dateFormat);
        if (this.showTime) {
          formattedValue += ' ' + this.formatTime(date);
        }
      }
    }

    //console.log("calendar-date:formatDateTime ret:" + formattedValue);
    //console.log("calendar-date:formatDateTime [END]");
    return formattedValue;
  }

  selectDate(dateMeta) {
    let date;
    if (this.utc)
      date = new Date(Date.UTC(dateMeta.year, dateMeta.month, dateMeta.day));
    else date = new Date(dateMeta.year, dateMeta.month, dateMeta.day);

    if (this.showTime) {
      if (this.hourFormat === '12' && this.pm && this.currentHour != 12)
        date.setHours(this.currentHour + 12);
      else date.setHours(this.currentHour);

      date.setMinutes(this.currentMinute);
      date.setSeconds(this.currentSecond);
    }

    if (this.isSingleSelection()) {
      this.updateModel(date);
    } else if (this.isMultipleSelection()) {
      this.updateModel(this.value ? [...this.value, date] : [date]);
    } else if (this.isRangeSelection()) {
      if (this.value && this.value.length) {
        let startDate = this.value[0];
        let endDate = this.value[1];

        if (!endDate && date.getTime() > startDate.getTime()) {
          endDate = date;
        } else {
          startDate = date;
          endDate = null;
        }

        this.updateModel([startDate, endDate]);
      } else {
        this.updateModel([date, null]);
      }
    }

    this.onSelect.emit(date);
  }

  updateModel(value) {
    this.value = value;
    let isInvalid = false;
    if (value == null && this.datainputem != null) {
      if (isNaN(new Date(this.datainputem).getTime())) {
        isInvalid = true;
      }
      this.datainputem = null;
    }

    if (this.dataType == 'date') {
      this.onModelChange(this.value);
      this.onData.emit({
        value: this.value,
        format: this.formatDate(this.value, this.dateFormat),
        invalid: isInvalid
      });
    } else if (this.dataType == 'string') {
      this.onModelChange(this.formatDateTime(this.value));
      this.onData.emit({
        value: this.value,
        format: this.formatDate(this.value, this.dateFormat),
        invalid: isInvalid
      });
    }
  }

  getFirstDayOfMonthIndex(month: number, year: number) {
    let day = new Date();
    day.setDate(1);
    day.setMonth(month);
    day.setFullYear(year);

    let dayIndex = day.getDay() + this.getSundayIndex();
    return dayIndex >= 7 ? dayIndex - 7 : dayIndex;
  }

  getDaysCountInMonth(month: number, year: number) {
    return 32 - this.daylightSavingAdjust(new Date(year, month, 32)).getDate();
  }

  getDaysCountInPrevMonth(month: number, year: number) {
    let prev = this.getPreviousMonthAndYear(month, year);
    return this.getDaysCountInMonth(prev.month, prev.year);
  }

  getPreviousMonthAndYear(month: number, year: number) {
    let m, y;

    if (month === 0) {
      m = 11;
      y = year - 1;
    } else {
      m = month - 1;
      y = year;
    }

    return { month: m, year: y };
  }

  getNextMonthAndYear(month: number, year: number) {
    let m, y;

    if (month === 11) {
      m = 0;
      y = year + 1;
    } else {
      m = month + 1;
      y = year;
    }

    return { month: m, year: y };
  }

  getSundayIndex() {
    return this.locale.firstDayOfWeek > 0 ? 7 - this.locale.firstDayOfWeek : 0;
  }

  isSelected(dateMeta): boolean {
    if (this.value) {
      if (this.isSingleSelection()) {
        return this.isDateEquals(this.value, dateMeta);
      } else if (this.isMultipleSelection()) {
        let selected = false;
        for (let date of this.value) {
          selected = this.isDateEquals(date, dateMeta);
          if (selected) {
            break;
          }
        }

        return selected;
      } else if (this.isRangeSelection()) {
        if (this.value[1])
          return (
            this.isDateEquals(this.value[0], dateMeta) ||
            this.isDateEquals(this.value[1], dateMeta) ||
            this.isDateBetween(this.value[0], this.value[1], dateMeta)
          );
        else return this.isDateEquals(this.value[0], dateMeta);
      }
    } else return false;
  }

  isDateEquals(value, dateMeta) {
    if (value)
      return (
        value.getDate() === dateMeta.day &&
        value.getMonth() === dateMeta.month &&
        value.getFullYear() === dateMeta.year
      );
    else return false;
  }

  isDateBetween(start, end, dateMeta) {
    if (start && end) {
      return (
        start.getDate() < dateMeta.day &&
        start.getMonth() <= dateMeta.month &&
        start.getFullYear() <= dateMeta.year &&
        end.getDate() > dateMeta.day &&
        end.getMonth() >= dateMeta.month &&
        end.getFullYear() >= dateMeta.year
      );
    } else {
      return false;
    }
  }

  isSingleSelection(): boolean {
    return this.selectionMode === 'single';
  }

  isRangeSelection(): boolean {
    return this.selectionMode === 'range';
  }

  isMultipleSelection(): boolean {
    return this.selectionMode === 'multiple';
  }

  isToday(today, day, month, year): boolean {
    return (
      today.getDate() === day &&
      today.getMonth() === month &&
      today.getFullYear() === year
    );
  }

  isSelectable(day, month, year): boolean {
    let validMin = true;
    let validMax = true;
    let validDate = true;
    let validDay = true;

    if (this.minDate) {
      if (this.minDate.getFullYear() > year) {
        validMin = false;
      } else if (this.minDate.getFullYear() === year) {
        if (this.minDate.getMonth() > month) {
          validMin = false;
        } else if (this.minDate.getMonth() === month) {
          if (this.minDate.getDate() > day) {
            validMin = false;
          }
        }
      }
    }

    if (this.maxDate) {
      if (this.maxDate.getFullYear() < year) {
        validMax = false;
      } else if (this.maxDate.getFullYear() === year) {
        if (this.maxDate.getMonth() < month) {
          validMax = false;
        } else if (this.maxDate.getMonth() === month) {
          if (this.maxDate.getDate() < day) {
            validMax = false;
          }
        }
      }
    }

    if (this.disabledDates) {
      validDate = !this.isDateDisabled(day, month, year);
    }

    if (this.disabledDays) {
      validDay = !this.isDayDisabled(day, month, year);
    }

    return validMin && validMax && validDate && validDay;
  }

  isDateDisabled(day: number, month: number, year: number): boolean {
    if (this.disabledDates) {
      for (let disabledDate of this.disabledDates) {
        if (
          disabledDate.getFullYear() === year &&
          disabledDate.getMonth() === month &&
          disabledDate.getDate() === day
        ) {
          return true;
        }
      }
    }

    return false;
  }

  isDayDisabled(day: number, month: number, year: number): boolean {
    if (this.disabledDays) {
      let weekday = new Date(year, month, day);
      let weekdayNumber = weekday.getDay();
      return this.disabledDays.indexOf(weekdayNumber) !== -1;
    }
    return false;
  }

  onInputFocus(event: Event) {
    this.focus = true;
    if (this.showOnFocus) {
      this.showOverlay();
    }
    this.onFocus.emit(event);
  }

  onInputBlur(event) {
    // console.log("calendar-date:onInputBlur [START]");
    if (event.target.value === '' && this.value !== '') {
      this.value = '';
    }
    if (this.value) {
      this.updateInputfield();
    }
    this.focus = false;
    // this.checkdateinput(this.value);

    this.onModelTouched();
    //console.log("calendar-date:onInputBlur [END]");
    this.onBlur.emit({
      value: this.value,
      format: this.formatDate(this.value, this.dateFormat),
      eventinput: this.datainputem,
      statusyear: this.statusyear
    });
  }

  onButtonClick(event, inputfield) {
    if (
      !this.overlayViewChild.nativeElement.offsetParent ||
      this.overlayViewChild.nativeElement.style.display === 'none'
    ) {
      inputfield.focus();
      this.showOverlay();
    } else {
      this.overlayVisible = false;
    }

    this.datepickerClick = true;
  }

  onInputKeydown(event) {
    this.isKeydown = true;
    if (event.keyCode === 9) {
      this.overlayVisible = false;
    }
  }

  onMonthDropdownChange(m: string) {
    this.currentMonth = parseInt(m);
    this.createMonth(this.currentMonth, this.currentYear);
  }

  onYearDropdownChange(y: string) {
    // console.log(y);
    this.oncheckvalue(y);
    this.currentYear = parseInt(y);
    this.createMonth(this.currentMonth, this.currentYear);
  }

  incrementHour(event) {
    let newHour = this.currentHour + this.stepHour;
    if (this.hourFormat == '24')
      this.currentHour = newHour >= 24 ? newHour - 24 : newHour;
    else if (this.hourFormat == '12')
      this.currentHour = newHour >= 13 ? newHour - 12 : newHour;

    this.updateTime();

    event.preventDefault();
  }

  decrementHour(event) {
    let newHour = this.currentHour - this.stepHour;
    if (this.hourFormat == '24')
      this.currentHour = newHour < 0 ? 24 + newHour : newHour;
    else if (this.hourFormat == '12')
      this.currentHour = newHour <= 0 ? 12 + newHour : newHour;

    this.updateTime();

    event.preventDefault();
  }

  incrementMinute(event) {
    let newMinute = this.currentMinute + this.stepMinute;
    this.currentMinute = newMinute > 59 ? newMinute - 60 : newMinute;

    this.updateTime();

    event.preventDefault();
  }

  decrementMinute(event) {
    let newMinute = this.currentMinute - this.stepMinute;
    this.currentMinute = newMinute < 0 ? 60 + newMinute : newMinute;

    this.updateTime();

    event.preventDefault();
  }

  incrementSecond(event) {
    let newSecond = this.currentSecond + this.stepSecond;
    this.currentSecond = newSecond > 59 ? newSecond - 60 : newSecond;

    this.updateTime();

    event.preventDefault();
  }

  decrementSecond(event) {
    let newSecond = this.currentSecond - this.stepSecond;
    this.currentSecond = newSecond < 0 ? 60 + newSecond : newSecond;

    this.updateTime();

    event.preventDefault();
  }

  updateTime() {
    // console.log("calendar-date:updateTime [START]");
    let value = this.value || new Date();
    if (this.hourFormat === '12' && this.pm && this.currentHour != 12)
      value.setHours(this.currentHour + 12);
    else value.setHours(this.currentHour);

    value.setMinutes(this.currentMinute);
    value.setSeconds(this.currentSecond);
    this.updateModel(value);
    this.onSelect.emit(value);
    this.updateInputfield();
    //console.log("calendar-date:updateTime [END]");
  }

  toggleAMPM(event) {
    this.pm = !this.pm;
    this.updateTime();
    event.preventDefault();
  }

  onUserInput(event) {
    // IE 11 Workaround for input placeholder : https://github.com/primefaces/primeng/issues/2026
    if (!this.isKeydown) {
      return;
    }
    //console.log("calendar-date: onUserInput [START]");
    //console.log("onUserInput value: " + event.target.value);
    //console.log("onUserInput kanjidate:" + this.kanjidate);

    let val = event.target.value;
    let valdatestring: string = val;
    let strvalue: string;
    this.isKeydown = false;
    this.datainputem = val;
    try {
      if (this.autoformat && val) {
        valdatestring = val.replace(/\//g, '');
        const length = valdatestring.length;
        if (length === 2 || (this.kanjidate === 0 && length === 4)) {
         this.dateFormat = 'yy';
         this.statusyear = 1;
        } else if (length === 4 || (this.kanjidate === 0 && length === 6)) {
          this.dateFormat = 'yy/mm';
          this.statusyear = 0;
        } else if (length === 6 || (this.kanjidate === 0 && length === 8)) {
            this.dateFormat = 'yy/mm/dd';
            this.statusyear = 2;
        }
        let y, m = '01', d = '01', ylength = 2;
        if (this.kanjidate === 0) {
          if (length >= 4) {
            y = valdatestring.substring(0, 4);
            ylength = 4;
          }
        } else {
          if (length >= 2) {
            y = this.getModeDate(this.kanjidate) + Number(valdatestring.substring(0, 2));
          }
        }
        if (y) {
          if (length >= ylength + 2) {
            m = valdatestring.substring(ylength, ylength + 2);
          }
          if (length >= ylength + 4) {
            d = valdatestring.substring(ylength + 2, ylength + 4);
          }
          strvalue = y + '/' + m + '/' + d;
          const value = this.parseDate(strvalue, 'yy/mm/dd');
          this.updateModel(value);
          this.updateUI();
        }
        return;
      } else if (valdatestring.length === 6 || (this.kanjidate > 0 && valdatestring.length === 8) ) {
        strvalue = this.strdateinput(valdatestring);
        this.checkdate(strvalue);
      } else if (valdatestring.length === 7) {
        strvalue = this.strdateinput(valdatestring);
        this.checkdate(strvalue);
      } else if (valdatestring.length === 10) {
        strvalue =
          valdatestring.substring(0, 4) +
          valdatestring.substring(4, 5) +
          valdatestring.substring(5, 7) +
          valdatestring.substring(7, 8) +
          valdatestring.substring(8, 10);
      } else if (valdatestring.length === 4 && this.kanjidate > 0) {
        strvalue =
          (
            this.getModeDate(this.kanjidate) +
            Number(valdatestring.substring(0, 2))
          ).toString() +
          '/' +
          valdatestring.substring(2, 4);
      } else if (valdatestring.length === 5) {
        strvalue =
          (
            this.getModeDate(this.kanjidate) +
            Number(valdatestring.substring(0, 2))
          ).toString() +
          valdatestring.substring(2, 3) +
          valdatestring.substring(3, 5);
      } else if (valdatestring.length === 7) {
        strvalue =
          (
            this.getModeDate(this.kanjidate) +
            Number(valdatestring.substring(0, 4))
          ).toString() +
          valdatestring.substring(4, 5) +
          valdatestring.substring(5, 7);
      } else if (this.kanjidate === 0 && valdatestring.length === 6) {
        strvalue =
          valdatestring.substring(0, 4) +
          '/' +
          valdatestring.substring(4, 6);
      } else if (this.kanjidate === 0 && valdatestring.length === 8) {
        // Here's YYYYMMDD
        strvalue =
          valdatestring.substring(0, 4) +
          '/' +
          valdatestring.substring(4, 6) +
          '/' +
          valdatestring.substring(6, 8);
      }

      if (strvalue) {
        const value = this.parseValueFromString(strvalue);
        this.updateModel(value);
        this.updateUI();
      }
    } catch (err) {
      this.updateModel(null);
    }

    this.filled = val != null && val.length;
    this.onInput.emit(event);
    this.onDataInput.emit(this.value);
    this.onData.emit({
      value: this.value,
      format: this.formatDate(this.value, this.dateFormat)
    });
  }

  parseValueFromString(text: string): Date {
    if (!text || text.trim().length === 0) {
      return null;
    }

    let value: any;

    if (this.isSingleSelection()) {
      value = this.parseDateTime(text);
    } else if (this.isMultipleSelection()) {
      let tokens = text.split(',');
      value = [];
      for (let token of tokens) {
        value.push(this.parseDateTime(token.trim()));
      }
    } else if (this.isRangeSelection()) {
      let tokens = text.split(' - ');
      value = [];
      for (let i = 0; i < tokens.length; i++) {
        value[i] = this.parseDateTime(tokens[i].trim());
      }
    }

    return value;
  }

  parseDateTime(text): Date {
    let date: Date;
    let parts: string[] = text.split(' ');

    if (this.timeOnly) {
      date = new Date();
      this.populateTime(date, parts[0], parts[1]);
    } else {
      if (this.showTime) {
        date = this.parseDate(parts[0], this.dateFormat);
        this.populateTime(date, parts[1], parts[2]);
      } else {
        date = this.parseDate(text, this.dateFormat);
      }
    }

    return date;
  }

  populateTime(value, timeString, ampm) {
    if (this.hourFormat == '12' && !ampm) {
      throw 'Invalid Time';
    }

    this.pm = ampm === 'PM' || ampm === 'pm';
    let time = this.parseTime(timeString);
    value.setHours(time.hour);
    value.setMinutes(time.minute);
    value.setSeconds(time.second);
  }

  updateUI() {
    let val = this.value || this.defaultDate || new Date();
    this.createMonth(val.getMonth(), val.getFullYear());

    if (this.showTime || this.timeOnly) {
      let hours = val.getHours();

      if (this.hourFormat == '12') {
        if (hours >= 12) {
          this.currentHour = hours == 12 ? 12 : hours - 12;
        } else {
          this.currentHour = hours == 0 ? 12 : hours;
        }
      } else {
        this.currentHour = val.getHours();
      }

      this.currentMinute = val.getMinutes();
      this.currentSecond = val.getSeconds();
    }
  }

  onDatePickerClick(event) {
    this.datepickerClick = true;
  }

  showOverlay() {
    this.overlayVisible = true;
    this.overlayShown = true;
    this.overlayViewChild.nativeElement.style.zIndex = String(
      ++DomHandler.zindex
    );

    this.bindDocumentClickListener();
  }

  alignOverlay() {
    if (this.appendTo)
      this.domHandler.absolutePosition(
        this.overlayViewChild.nativeElement,
        this.inputfieldViewChild.nativeElement
      );
    else
      this.domHandler.relativePosition(
        this.overlayViewChild.nativeElement,
        this.inputfieldViewChild.nativeElement
      );
  }

  writeValue(value: any): void {
    // console.log("calendar-date:writeValue [START]");
    // if (this.value != value && value != null && this.value != null) {
      this.value = value;
      //console.log(this.value);
      if (this.value && typeof this.value === 'string') {
        this.value = this.parseValueFromString(this.value);
      }
      if (this.value){
        this.kanjidate = this._oncheckvalue(this.value);
        // this.kanjidate = this._oncheckvalue(this.value.getFullYear(), this.value.getMonth(), this.value.getDate());
      }

      this.updateInputfield();
      this.updateUI();
    // }

    //console.log("calendar-date:writeValue kanjidate:" + this.kanjidate);
    //console.log("calendar-date:writeValue [END]");
  }

  registerOnChange(fn: Function): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: Function): void {
    this.onModelTouched = fn;
  }

  setDisabledState(val: boolean): void {
    this.disabled = val;
  }

  // Ported from jquery-ui datepicker formatDate
  formatDate(date, format) {
    if (!date) {
      return '';
    }
    //console.log("calendar-date: formatDate [START]");

    let iFormat,
      lookAhead = match => {
        let matches =
          iFormat + 1 < format.length && format.charAt(iFormat + 1) === match;
        if (matches) {
          iFormat++;
        }
        return matches;
      },
      formatNumber = (match, value, len) => {
        let num = '' + value;
        if (lookAhead(match)) {
          while (num.length < len) {
            num = '0' + num;
          }
        }
        return num;
      },
      formatName = (match, value, shortNames, longNames) => {
        return lookAhead(match) ? longNames[value] : shortNames[value];
      },
      output = '',
      literal = false;

    if (date) {
      for (iFormat = 0; iFormat < format.length; iFormat++) {
        if (literal) {
          if (format.charAt(iFormat) === "'" && !lookAhead("'"))
            literal = false;
          else output += format.charAt(iFormat);
        } else {
          switch (format.charAt(iFormat)) {
            case 'd':
              output += formatNumber('d', date.getDate(), 2);
              break;
            case 'D':
              output += formatName(
                'D',
                date.getDay(),
                this.locale.dayNamesShort,
                this.locale.dayNames
              );
              break;
            case 'o':
              output += formatNumber(
                'o',
                Math.round(
                  (new Date(
                    date.getFullYear(),
                    date.getMonth(),
                    date.getDate()
                  ).getTime() -
                    new Date(date.getFullYear(), 0, 0).getTime()) /
                    86400000
                ),
                3
              );
              break;
            case 'm':
              output += formatNumber('m', date.getMonth() + 1, 2);
              break;
            case 'M':
              output += formatName(
                'M',
                date.getMonth(),
                this.locale.monthNamesShort,
                this.locale.monthNames
              );
              break;
            case 'y':
              let tmp_year = date.getFullYear() - this.getModeDate(this.kanjidate);
              let output_year = (Number(tmp_year) < 10 ? '0' : '') + tmp_year;
              output += lookAhead('y')
                ? output_year
                : (date.getFullYear() -
                    (this.getModeDate(this.kanjidate) % 100) <
                  10
                    ? '0'
                    : '') +
                  ((date.getFullYear() - this.getModeDate(this.kanjidate)) %
                    100);
              break;
            case '@':
              output += date.getTime();
              break;
            case '!':
              output += date.getTime() * 10000 + this.ticksTo1970;
              break;
            case "'":
              if (lookAhead("'")) output += "'";
              else literal = true;

              break;
            default:
              output += format.charAt(iFormat);
          }
        }
      }
    }
    // console.log("calendar-date: " + output);
    //console.log("calendar-date: formatDate [END]");
    return output;
  }

  formatTime(date) {
    if (!date) {
      return '';
    }

    let output = '';
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();

    if (this.hourFormat == '12' && hours > 11 && hours != 12) {
      hours -= 12;
    }

    output += hours < 10 ? '0' + hours : hours;
    output += ':';
    output += minutes < 10 ? '0' + minutes : minutes;

    if (this.showSeconds) {
      output += ':';
      output += seconds < 10 ? '0' + seconds : seconds;
    }

    if (this.hourFormat == '12') {
      output += date.getHours() > 11 ? ' PM' : ' AM';
    }

    return output;
  }

  parseTime(value) {
    let tokens: string[] = value.split(':');
    let validTokenLength = this.showSeconds ? 3 : 2;

    if (tokens.length !== validTokenLength) {
      throw 'Invalid time';
    }

    let h = parseInt(tokens[0]);
    let m = parseInt(tokens[1]);
    let s = this.showSeconds ? parseInt(tokens[2]) : null;

    if (
      isNaN(h) ||
      isNaN(m) ||
      h > 23 ||
      m > 59 ||
      (this.hourFormat == '12' && h > 12) ||
      (this.showSeconds && (isNaN(s) || s > 59))
    ) {
      throw 'Invalid time';
    } else {
      if (this.hourFormat == '12' && h !== 12 && this.pm) {
        h += 12;
      }

      return { hour: h, minute: m, second: s };
    }
  }

  // Ported from jquery-ui datepicker parseDate
  parseDate(value, format) {
    if (format == null || value == null) {
      throw 'Invalid arguments';
    }

    value = typeof value === 'object' ? value.toString() : value + '';
    if (value === '') {
      return null;
    }

    let iFormat,
      dim,
      extra,
      iValue = 0,
      shortYearCutoff =
        typeof this.shortYearCutoff !== 'string'
          ? this.shortYearCutoff
          : (new Date().getFullYear() % 100) +
            parseInt(this.shortYearCutoff, 10),
      year = -1,
      month = -1,
      day = -1,
      doy = -1,
      literal = false,
      date,
      lookAhead = match => {
        let matches =
          iFormat + 1 < format.length && format.charAt(iFormat + 1) === match;
        if (matches) {
          iFormat++;
        }
        return matches;
      },
      getNumber = match => {
        let isDoubled = lookAhead(match),
          size =
            match === '@'
              ? 14
              : match === '!'
                ? 20
                : match === 'y' && isDoubled
                  ? 4
                  : match === 'o'
                    ? 3
                    : 2,
          minSize = match === 'y' ? size : 1,
          digits = new RegExp('^\\d{' + minSize + ',' + size + '}'),
          num = value.substring(iValue).match(digits);
        if (!num) {
          throw 'Missing number at position ' + iValue;
        }
        iValue += num[0].length;
        return parseInt(num[0], 10);
      },
      getName = (match, shortNames, longNames) => {
        let index = -1;
        let arr = lookAhead(match) ? longNames : shortNames;
        let names = [];

        for (let i = 0; i < arr.length; i++) {
          names.push([i, arr[i]]);
        }
        names.sort((a, b) => {
          return -(a[1].length - b[1].length);
        });

        for (let i = 0; i < names.length; i++) {
          let name = names[i][1];
          if (
            value.substr(iValue, name.length).toLowerCase() ===
            name.toLowerCase()
          ) {
            index = names[i][0];
            iValue += name.length;
            break;
          }
        }

        if (index !== -1) {
          return index + 1;
        } else {
          throw 'Unknown name at position ' + iValue;
        }
      },
      checkLiteral = () => {
        if (value.charAt(iValue) !== format.charAt(iFormat)) {
          throw 'Unexpected literal at position ' + iValue;
        }
        iValue++;
      };

    for (iFormat = 0; iFormat < format.length; iFormat++) {
      if (literal) {
        if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
          literal = false;
        } else {
          checkLiteral();
        }
      } else {
        switch (format.charAt(iFormat)) {
          case 'd':
            day = getNumber('d');
            break;
          case 'D':
            getName('D', this.locale.dayNamesShort, this.locale.dayNames);
            break;
          case 'o':
            doy = getNumber('o');
            break;
          case 'm':
            month = getNumber('m');
            break;
          case 'M':
            month = getName(
              'M',
              this.locale.monthNamesShort,
              this.locale.monthNames
            );
            break;
          case 'y':
            year = getNumber('y');
            break;
          case '@':
            date = new Date(getNumber('@'));
            year = date.getFullYear();
            month = date.getMonth() + 1;
            day = date.getDate();
            break;
          case '!':
            date = new Date((getNumber('!') - this.ticksTo1970) / 10000);
            year = date.getFullYear();
            month = date.getMonth() + 1;
            day = date.getDate();
            break;
          case "'":
            if (lookAhead("'")) {
              checkLiteral();
            } else {
              literal = true;
            }
            break;
          default:
            checkLiteral();
        }
      }
    }

    if (iValue < value.length) {
      extra = value.substr(iValue);
      if (!/^\s+/.test(extra)) {
        throw 'Extra/unparsed characters found in date: ' + extra;
      }
    }

    if (year === -1) {
      year = new Date().getFullYear();
    } else if (year < 100) {
      year +=
        new Date().getFullYear() -
        (new Date().getFullYear() % 100) +
        (year <= shortYearCutoff ? 0 : -100);
    }

    if (doy > -1) {
      month = 1;
      day = doy;
      do {
        dim = this.getDaysCountInMonth(year, month - 1);
        if (day <= dim) {
          break;
        }
        month++;
        day -= dim;
      } while (true);
    }

    date = this.daylightSavingAdjust(new Date(year, month - 1, day));
    if (
      date.getFullYear() !== year ||
      date.getMonth() + 1 !== month ||
      date.getDate() !== day
    ) {
      throw 'Invalid date'; // E.g. 31/02/00
    }
    return date;
  }

  daylightSavingAdjust(date) {
    if (!date) {
      return null;
    }
    date.setHours(date.getHours() > 12 ? date.getHours() + 2 : 0);
    return date;
  }

  updateFilledState() {
    this.filled = this.inputFieldValue && this.inputFieldValue != '';
  }

  onTodayButtonClick(event) {
    let date: Date = new Date();
    let dateMeta = {
      day: date.getDate(),
      month: date.getMonth(),
      year: date.getFullYear(),
      today: true,
      selectable: true
    };

    this.onDateSelect(event, dateMeta);
    this.onTodayClick.emit(event);
  }

  onClearButtonClick(event) {
    //console.log("calendar-date:onClearButtonClick [START]");
    this.updateModel(null);
    this.updateInputfield();
    this.overlayVisible = false;
    this.onClearClick.emit(event);
    //console.log("calendar-date:onClearButtonClick [END]");
  }

  bindDocumentClickListener() {
    if (!this.documentClickListener) {
      this.documentClickListener = this.renderer.listen(
        'document',
        'click',
        event => {
          if (!this.datepickerClick && this.overlayVisible) {
            this.overlayVisible = false;
            this.onClose.emit(event);
          }

          this.datepickerClick = false;
          this.cd.detectChanges();
        }
      );
    }
  }

  unbindDocumentClickListener() {
    if (this.documentClickListener) {
      this.documentClickListener();
      this.documentClickListener = null;
    }
  }

  getModeDate(mode: any): number {
    // const showa = 1925; // 1926;
    // const heisei = 1988; // 1989;
    // if (mode == 2) {
    //   return heisei; // 1988;
    // } else if (mode == 1) {
    //   return showa;
    // } else {
    //   return 0;
    // }
    if (CALENDAR_YEAR[mode]) {
      return CALENDAR_YEAR[mode].Diff;
    }
    return 0;
  }

  Onclean(input: any) {
    if (CALENDAR_YEAR[input]) {
      this.onSwitch.emit({ name: CALENDAR_YEAR[input].Char, value: input });
    } else if (input == 0) {
      this.onSwitch.emit({ name: '', value: input });
    }

    if (this.onoffChanges) this.inputFieldValue = null;
    // this.yearOptions = [];
    // this.currentYear = null;
    // this.value = null;
  }

  onopenDatepicker() {
    if (this.ondateClick) {
      this.datepickerClick = false;
    } else {
      this.datepickerClick = true;
    }
  }

  seadEnterKey(event) {
    //console.log("calendar-date:seadEnterKey [START]");
    // console.log(event);
    this.onsendEnter.emit(true);
    this.updateInputfield();
    this.onModelTouched();
    this.overlayVisible = false;
    //console.log("calendar-date:seadEnterKey [END]");
  }

  onkeypress(event) {
    const strInput = event.target.value.replace(/\//g, '');
    let max = this.onmaxLength;
    if (this.kanjidate > 0) {
      max -= 2;
    }
    if (event.charCode > 0 && max != null && strInput.length >= max) {
      return false;
    }
  }

  oncheckvalue(valueinput, datemeate?) {
    // const showa = 1926; // 1926;
    // const heisei = 1989; // 1989;
    // console.log("calendar-date:oncheckvalue [START]");
    if (datemeate) {
      const date = new Date(datemeate.year, datemeate.month, datemeate.day);
      this.kanjidate = this._oncheckvalue(date);
      // this.kanjidate = this._oncheckvalue(datemeate.year,datemeate.month, datemeate.day);
    } else {
//       if (valueinput >= heisei) {
//         this.kanjidate = 2;
//       } else if (valueinput >= showa && valueinput <= heisei) {
//         this.kanjidate = 1;
//       } else {
//         this.kanjidate = 0;
//       }
    }
    //console.log("calendar-date:oncheckvalue: " + valueinput);
    //console.log("calendar-date:oncheckvalue: " + datemeate);
    //console.log("calendar-date:oncheckvalue: " + this.kanjidate);
    //console.log("calendar-date:oncheckvalue [END]");
  }

  _oncheckvalue(date: Date) {
    const era: any = this.util.findEra(date);
    if (era) {
     return era.Kbn;
    }
    return 0;
  }

  // _oncheckvalue(year:number,month:number,day:number) {
  //   //console.log("calendar-date:_oncheckvalue [START]");
  //   const showa = 1926; // 1926;
  //   const heisei = 1989; // 1989;
  //   let kanjidate = 0;

  //   if (year > heisei) {
  //      kanjidate = 2; // 1990以降はH
  //   } else if (year === heisei) {
  //     if (month === 0 && day <= 7) {
  //       kanjidate = 1; // 1989/1/1~1989/1/7 is S
  //     } else {
  //       kanjidate = 2; // 1989/1/8以降は H
  //     }
  //   } else if (year > showa && year < heisei) {
  //     kanjidate = 1; // 1927~1988は S
  //   } else if (year === showa) {
  //     if (month === 11 && day >= 25) {
  //       kanjidate = 1; // 1926/12/25~1926/12/31 S
  //     } else {
  //       kanjidate = 0; // 1926/1/1~1926/12/24以前は上記以外
  //     }
  //   }
  //   //console.log("calendar-date:_oncheckvalue :" + kanjidate);
  //   //console.log("calendar-date:_oncheckvalue [END]");
  //   return kanjidate;
  // }

  strdateinput(datemeate: string) {
    let stringdate = '';
    const strdate = datemeate.replace('\\', '');
    const datedata = this.planmainservice.getDate(strdate, 'YYYYMMDD');
    const arrstr = datemeate.split('/');
    if (arrstr[0] === '64') {
      stringdate = '1989' + '/' + arrstr[1] + '/' + arrstr[2];
      this.kanjidate = 2;
    } else if (datemeate.length === 8) {
      stringdate =
        (this.getModeDate(this.kanjidate) + +arrstr[0]).toString() +
        '/' +
        arrstr[1] +
        '/' +
        arrstr[2];
    } else if (datemeate.length === 7) {
      stringdate =
        (
          this.getModeDate(this.kanjidate) + Number(strdate.substring(0, 1))
        ).toString() +
        '/' +
        arrstr[1] +
        '/' +
        arrstr[2];
    } else {
      if (strdate.substring(0, 2) === '64' && arrstr[1] === '01') {
        stringdate =
          '1989' +
          '/' +
          strdate.substring(2, 4) +
          '/' +
          strdate.substring(4, 6);
      } else {
        stringdate =
          (
            this.getModeDate(this.kanjidate) + Number(strdate.substring(0, 2))
          ).toString() +
          '/' +
          strdate.substring(2, 4) +
          '/' +
          strdate.substring(4, 6);
      }
    }
    return stringdate;
  }

  checkdate(datestr: string) {
    /*
    const strdate = datestr.replace('\\', '');
    const arraydata = datestr.split('/');
    if (+arraydata[2] <= 7 && arraydata[1] === '01' && +arraydata[0] === 1989) {
      this.kanjidate = 1;
      this.onmodedropdown.emit('S');
    } else if (
      +arraydata[2] >= 8 &&
      arraydata[1] === '01' &&
      +arraydata[0] === 1989
    ) {
      this.kanjidate = 2;
      this.onmodedropdown.emit('H');
    }
    */
  }
  onkeyup(event) {
    if (event.target.value === '') {
      this.value = '';
    }
  }

  ngOnDestroy() {
    this.unbindDocumentClickListener();

    if (!this.inline && this.appendTo) {
      this.el.nativeElement.appendChild(this.overlayViewChild.nativeElement);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/calendar-date/calendar-date.component.ts